import React, { ComponentProps, ReactNode, useCallback } from 'react';
import { Collapse, Backdrop, Portal, styled } from '@mui/material';

const ANIMATION_TIMEOUT = 300;

const CollapseContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'stretch',
});

export const ModalContentContainer = styled('div')<ComponentProps<'div'>>(({ theme }) => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'start',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
}));

type ModalFullScreenDrawerProps = {
  open: boolean;
  children: ReactNode;
  onClose?(): void;
  onExited?(): void;
};

export const ModalFullScreenDrawer: React.FC<ModalFullScreenDrawerProps> = (props) => {
  const { open = false, children, onClose, onExited } = props;

  const onClick = useCallback(
    (e: React.MouseEvent) => {
      if (onClose !== undefined && e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Portal>
      <Backdrop open={open} onClick={onClick} timeout={ANIMATION_TIMEOUT}>
        <CollapseContainer>
          <Collapse appear in={open} onExited={onExited} timeout={ANIMATION_TIMEOUT} unmountOnExit>
            <ModalContentContainer>{children}</ModalContentContainer>
          </Collapse>
        </CollapseContainer>
      </Backdrop>
    </Portal>
  );
};
